import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";
// @ts-ignore
import * as countries from 'iso-3166-1-codes';
// @ts-ignore
import classNames from "classnames";

import LifeSelector from "./LifeSelector";
import YearSelector from "./YearSelector";
import TierBarchart from "./TierBarchart/TierBarchart";
import { Country } from "../../../interfaces/Country";
import { GlobalDataContext } from "../../../contexts/GlobalDataContext";
import RankingsAndLevelsUtils from "../../../services/RankingsAndLevelsUtils";

const Wrapper = styled.div`
  background-color: #737373;
  color: #ffffff;
  padding: 10%;
  display: flex;
  flex-direction: column;

  &.is-no-life-selected {
    background-color: #FFFFFF;
    color: #737373;

    & h3 {
      color: #737373;
    }
  }

  & .rankings-levels__wrapper {
    height: 100%;
    flex: 1 0 100%;
  }

  & h3 {
    color: #ffffff;
    font-size: 4.5rem;
    font-family: DMSans-Bold;
    padding-top: 10%;
    padding-bottom: 0.8em;
    margin: 0;
    line-height: 0.87em;
  }

  & .rankings-levels-description {
    font-family: DMSans-Light;
    font-size: 1.25rem;
    line-height: 1.3em;
    margin: 0;
    margin-bottom: 3em;
  }

  & .rankings-levels-description__separator {
    width: 70%;
    border-top: #F7F4F3;
    border-width: 3px;
    margin: 0;
    margin-top: 5%;
    margin-bottom: 5%;
  }

  & .explanatory-text {
    font-family: DMSans-Light;
    font-size: 0.8125rem;
    margin-top: 3em;
    margin-bottom: 3em;
  }

  & .tiers-barchart__wrapper {
    margin-top: 7.35em;
  }
`;

const RankingsAndLevels = () => {
  const { t } = useTranslation();

  // @ts-ignore
  const { allDataLoaded, last10YearReports } = useContext(GlobalDataContext);
  const [ records, setRecords ] = useState<any>();
  // @ts-ignore
  const [ yearSelected, setYearSelected ] = useState<number>(null);
  // @ts-ignore
  const [ isLife, setIsLife ] = useState<boolean>(true);

  useEffect(() => {
    if (allDataLoaded) {
      const report = last10YearReports[yearSelected];
      if (!report)
        return;

      let records = report.records.map((country: any) => {
        let info = countries.byAlpha3().get(country.country_code);

        return { name: info.name,
                 gip: Number(country.gip),
                 alpha2: info.alpha2,
                 alpha3: info.alpha3,
                 tier: country.tier,
                 is_life: country.is_life }
      });

      setRecords(records);
    }
  }, [allDataLoaded, yearSelected]);

  return (
    <Wrapper className={ classNames({ 'is-no-life-selected': !isLife }) }>
      <div className='rankings-levels__wrapper'>
        <h3>{ t('rankingsAndLevels.title') }</h3>
        <p className='rankings-levels-description'>
          { t('rankingsAndLevels.description') }
        </p>
        <hr className='rankings-levels-description__separator'></hr>
        <LifeSelector isLife={ isLife } setIsLife={ setIsLife } />
        <p className='explanatory-text'></p>
        <YearSelector yearSelected={ yearSelected } setYearSelected={ setYearSelected } />
      </div>
      <div className='tiers-barchart__wrapper'>
        { records &&
          <>
            <TierBarchart
              tier={ 1 }
              records={ records.filter((record: any) => record.tier === 1 && record.is_life === isLife) }
              isLife={ isLife }
            />
            <TierBarchart
              tier={ 2 }
              records={ records.filter((record: any) => record.tier === 2 && record.is_life === isLife) }
              isLife={ isLife }
            />
            <TierBarchart
              tier={ 3 }
              records={ records.filter((record: any) => record.tier === 3 && record.is_life === isLife) }
              isLife={ isLife }
            />
          </>
        }
      </div>
    </Wrapper>
  );
};

export default RankingsAndLevels;
